
import { mapState } from "vuex";

import { getVariantTitle } from "~/utils/shopify-utils";
import { tagableMixin } from "~/mixins";

let DIMENSION = "60";

export default {
  mixins: [tagableMixin],

  props: {
    selectedVariant: { type: Object, default: () => {} },
    product: { type: Object, required: true },
    image: { type: Object, default: () => {} },
    priorityCampaign: { type: Object, default: () => {} },
  },

  computed: {
    ...mapState({ topBannerHeight: s => s.app.topBannerHeight }),
    tags() {
      return this.product.tags ?? [];
    },
    imageOptions() {
      return {
        src: this.image.w_60_h_60,
        webpSrc: this.image.w_60_h_60_webp,
        alt: this.image.altText,
        widths: [DIMENSION],
        width: DIMENSION,
        height: DIMENSION,
      };
    },
    productTitle() {
      const variantTitle = getVariantTitle({
        variant: this.selectedVariant,
        isMultiVariant: this.isMultiVariant,
      });

      return `${this.product.title} ${variantTitle}`;
    },
    showCompareAtPrice() {
      return this.canShowCompareAtPrice(
        this.priorityCampaign,
        this.selectedVariant.compareAtPrice,
        this.selectedVariant.price
      );
    },
  },
};
